import * as React from 'react';

export const NaturalGasIcon = () => (
  <svg width="128" height="128" viewBox="0 0 128 128">
    <defs>
      <path
        id="natural-gas-icon-a"
        d="M127.975479,63.9866249 C127.975479,99.3259495 99.3259494,127.973249 63.9866249,127.973249 C28.6473006,127.973249 0,99.3259495 0,63.9866249 C0,28.6473006 28.6473006,1.42108547e-14 63.9866249,1.42108547e-14 C99.3259494,1.42108547e-14 127.975479,28.6473006 127.975479,63.9866249"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="natural-gas-icon-b" fill="#fff">
        <use xlinkHref="#natural-gas-icon-a" />
      </mask>
      <use fill="#F7F7F7" fillRule="nonzero" xlinkHref="#natural-gas-icon-a" />
      <g fillRule="nonzero" mask="url(#natural-gas-icon-b)">
        <g transform="translate(41 88.785)">
          <path
            fill="#C7C7C7"
            d="M32.8065627,7.81748267 L32.8065627,0.0773828423 L39.1914134,0.0773828423 L39.1914134,7.81748267 L41.9498787,7.81748267 C43.8806864,7.81748267 45.4460175,9.7344655 45.4460175,12.0992296 L45.381718,13.5207087 L0.85546116,13.5207087 L0.840296165,12.0992296 C0.840296165,9.7344655 2.40562736,7.81748267 4.33643503,7.81748267 L7.98589252,7.81748267 L7.98589252,0.0773828423 L14.3707432,0.0773828423 L14.3707432,7.81748267 L20.7273054,7.81748267 L20.7273054,0.0773828423 L27.112156,0.0773828423 L27.112156,7.81748267 L32.8065627,7.81748267 Z"
          />
          <polygon fill="#E3E3E3" points=".858 12.538 45.464 12.538 45.464 16.816 .858 16.816" />
        </g>
      </g>
      <g fill-rule="nonzero" mask="url(#natural-gas-icon-b)">
        <g transform="translate(41 22)">
          <path
            fill="#0A5FD2"
            d="M0.0144379308,35.4157748 L0.000783406043,35.4158778 C-0.157007626,15.9555038 23.5742666,-4.61852804e-15 23.5742666,-4.61852804e-15 C23.5742666,-4.61852804e-15 47.5623933,15.5961609 47.7205381,35.0561943 L47.7068682,35.0562974 C47.7179432,35.3151538 47.7245758,35.5751292 47.7266941,35.8361556 C47.8300012,48.522491 37.2311147,58.8875737 24.0537955,58.986691 C10.8764764,59.0858083 0.110246493,48.8821745 0.0072931694,36.1958391 C0.00516757828,35.9348118 0.00757274742,35.6747673 0.0144379308,35.4157748 Z"
          />
          <path
            fill="#9BCCEC"
            d="M11.1954422,41.8349539 L11.1886784,41.8350024 C11.1083854,32.4274731 23.1617672,24.7139799 23.1617672,24.7139799 C23.1617672,24.7139799 35.3457321,32.2536185 35.4260252,41.6611478 L35.4191018,41.6611975 C35.4247249,41.7863118 35.4280926,41.9119668 35.4291683,42.0381297 C35.4817445,48.170959 30.0983979,53.1818496 23.4055035,53.2297643 C16.7123236,53.2776791 11.244112,48.3448137 11.1918215,42.2119843 C11.1907399,42.0858215 11.1919588,41.9601335 11.1954422,41.8349539 Z"
          />
        </g>
      </g>
    </g>
  </svg>
);
